import React from "react"
import Select from "react-select"

const Bedrooms = ({
  bedroomVal,
  handleChange,
  bedPlus = true,
  maximumBeds = 5,
  studio = true,
}) => {
  const bedVal = [{ value: "", label: "Bedrooms" }]
  if (studio) {
    bedVal.push({ value: 0, label: "Studio" })
  }
  for (let i = 1; i <= maximumBeds; i++) {
    if (bedPlus) {
      bedVal.push({ value: i, label: `${i}+` })
    } else {
      bedVal.push({ value: i, label: `${i}` })
    }
  }

  return (
    <div className="select-option dropdown">
      <Select
        options={bedVal}
        placeholder="Bedrooms"
        className="react-select"
        classNamePrefix="react-select"
        onChange={(event) => handleChange(event.value)}
        value={bedVal.filter((item) => item.value === parseInt(bedroomVal, 10))}
      />
    </div>
  )
}
export default Bedrooms
